// extracted by mini-css-extract-plugin
module.exports = {"fill-parent":"fill-parent__195SA","close-icon":"close-icon__1zWj6"};